import React from 'react'
import './Loading.css'

function Loading() {
  return (
    <div className="loader-wrapper2">
      <div className="loadingio-spinner-ripple-g42tsysya4">
        <div className="ldio-8yhnsrjvsdu">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default Loading